import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';
import apiClient from '../../services/apiClient';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    apiClient.get('/api/admin/stats').then(data => setStats(data.stats)).catch(() => {});
  }, []);

  return (
    <AdminLayout>
        <h1>Dashboard</h1>

        {stats && (
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-value">{stats.users.total}</div>
              <div className="stat-label">Total Users</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.users.active}</div>
              <div className="stat-label">Active Users</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.users.with_mfa}</div>
              <div className="stat-label">Users with MFA</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.security.successful_logins_24h}</div>
              <div className="stat-label">Logins (24h)</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.security.failed_logins_24h}</div>
              <div className="stat-label">Failed Logins (24h)</div>
            </div>
          </div>
        )}

        <h2 style={{ marginBottom: '1rem' }}>Quick Links</h2>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <Link to="/admin/users" className="btn btn-secondary">Manage Users</Link>
          <Link to="/admin/sessions" className="btn btn-secondary">View Sessions</Link>
          <Link to="/admin/security" className="btn btn-secondary">Security Events</Link>
          <Link to="/admin/applications" className="btn btn-secondary">Applications</Link>
        </div>
    </AdminLayout>
  );
}
